export default {
  "retry": "Retry",
  "emptyDescription": "Data will appear once the sampler collects metrics",
  "zoomControls": "Chart zoom controls",
  "zoomIn": "Zoom in",
  "zoomOut": "Zoom out",
  "resetZoom": "Reset zoom",
  "cpuMetrics": "CPU Metrics",
  "usageDescription": "Usage breakdown + load averages",
  "updated": "Updated {{time}}",
  "legend": "Legend",
  "usageSeries": "Usage series",
  "clamp": "Clamp 0–100%",
  "showSeries": "Show {{series}}",
  "hideSeries": "Hide {{series}}",
  "topProcesses": "Top processes",
  "noProcesses": "No process data yet",
  "cpuEmpty": "No CPU telemetry available yet",
  "cpuLoading": "Loading CPU telemetry…",
  "cpuError": "Could not load CPU telemetry.",
  "cpuUsageChart": "CPU usage breakdown over time",
  "cpuLoad": "CPU Load",
  "cpuLoadChart": "CPU load averages over 1, 5 and 15 minutes",
  "loadMinutes": "Load {{minutes}} min",
  "total": "Total",
  "seriesUser": "User",
  "seriesSystem": "System",
  "seriesIowait": "I/O wait",
  "seriesNice": "Nice",
  "seriesIrq": "IRQ",
  "seriesSoftirq": "SoftIRQ",
  "seriesSteal": "Steal",
  "seriesGuest": "Guest",
  "rss": "{{bytes}} RSS",
  "exportCsv": "Export CSV",
  "exportJson": "Export JSON",
  "exportImage": "Save as Image",
  "csvDescription": "Spreadsheet format",
  "jsonDescription": "Structured data",
  "pngDescription": "PNG screenshot",
  "exportChart": "Export chart data",
  "exportOptions": "Export options",
  "exportData": "Export Data",
  "playbackToolbar": "Timeseries playback controls",
  "playbackControls": "Playback controls",
  "pause": "Pause",
  "play": "Play",
  "rewind": "Rewind {{duration}}",
  "forward": "Forward {{duration}}",
  "jumpLive": "Jump to live",
  "newData": "New data available",
  "timeRange": "Time range"
} as const;
